import { createContext } from "react";

import type Keycloak from "keycloak-js";

export interface KeycloakContextType {
  keycloak: Keycloak;
  initialized: boolean;
  authenticated: boolean;
}

export const KeycloakContext = createContext<KeycloakContextType | null>(null);
